import { useEffect, useState } from "react";
import { useTranslation } from "../components/Localization";
import { getPage, PageGame } from "../services/pagesApi";

export function usePageGame(slug: string, type: PageGame["type"]) {
  const { language } = useTranslation();
  const [game, setGame] = useState<PageGame | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    setGame(null);
    setLoading(true);
    getPage(slug, language, controller.signal)
      .then((page) => setGame(page.games.find((item) => item.type === type) || null))
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === "AbortError") return;
        setGame(null);
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [language, slug, type]);

  return { game, loading };
}
